module.exports = "<div class=\"filter-window\">\n    <div class=\"flex\">\n        <div class=\"dbm dbm-filter-icon\"></div>\n        <div class=\"report-filter-title\">Filters</div>\n        <div class=\"dbm dbm-back-icon\" ng-click=\"vm.isCollapsed = !vm.isCollapsed\" ng-class=\"{ expanded: !vm.isCollapsed, collapsed: vm.isCollapsed }\"></div>\n    </div>\n    <report-filter-summrize ng-hide=\"vm.isCollapsed\" data=\"\" on-filter=\"vm.filter(data)\"></report-filter-summrize>\n</div>\n<report-summery-data data=\"vm.report\"></report-summery-data>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/reports/report-summrize/reports.tpl.html
// module id = 1833
// module chunks = 0